import { useEffect, useState } from 'react';

export const useGameCodes = ({ gameCodes, parentEl, expanded }) => {
    const defaultPartSize = 7;
    const tabletPartSize = 40;
    const defaultGamesBeforeRender = 4;

    const [gamesBeforeRender, setGamesBeforeRender] = useState(defaultGamesBeforeRender);
    const [gameCodesInitial, setGameCodesInitial] = useState(gameCodes);
    const [partSize, setPartSize] = useState(defaultPartSize);
    const [codes, setCodes] = useState(gameCodesInitial.slice(0, partSize));
    const [observer, setObserver] = useState(null);
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [observableEl, setObservableEl] = useState(null);

    const createObserver = () => {
        const el = parentEl.current?.childNodes.item(codes.length - gamesBeforeRender);
        if (el) {
            setObservableEl(el);
            observer.observe(el);
        }
    };

    useEffect(() => {
        if (gameCodesInitial.length !== gameCodes.length) {
            setCodes(gameCodes);
            setGameCodesInitial(gameCodes);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameCodes]);

    useEffect(() => {
        const newObserver = new IntersectionObserver(
            ([entry]) => setIsIntersecting(entry.isIntersecting),
            {
                root: null,
                rootMargin: '0px',
                threshold: 1.0
            }
        );

        setObserver(newObserver);

        return () => newObserver.disconnect();
    }, []);

    useEffect(() => {
        if (observer) {
            createObserver();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observer, codes]);

    useEffect(() => {
        if (isIntersecting && gameCodes.length !== codes.length) {
            setCodes([...codes, ...gameCodes.slice(codes.length, codes.length + partSize)]);
            observer?.unobserve(observableEl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isIntersecting]);

    useEffect(() => {
        if (expanded) {
            setCodes([...codes, ...gameCodes.slice(codes.length, codes.length + tabletPartSize)]);
            observer.unobserve(observableEl);
            setPartSize(tabletPartSize);
            setGamesBeforeRender(1);
        } else if (!expanded) {
            setPartSize(defaultPartSize);
            setGamesBeforeRender(defaultGamesBeforeRender);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expanded]);

    return codes;
};
